
import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import PatientAppointments from '@/pages/staff/PatientAppointments';
import PatientCredits from '@/pages/staff/PatientCredits';
import PatientTreatments from '@/pages/staff/PatientTreatments';
import PatientNotes from '@/pages/staff/PatientNotes';
import PatientLedger from '@/pages/staff/PatientLedger';

const PatientDetailOutlet = () => {
  const { id } = useParams();
  const location = useLocation();
  
  // Determine which component to render based on the current path
  const getCurrentComponent = () => {
    const path = location.pathname.split('/').pop();
    
    switch (path) {
      case 'appointments':
        return <PatientAppointments />;
      case 'credits':
        return <PatientCredits />;
      case 'treatments':
        return <PatientTreatments />;
      case 'notes':
        return <PatientNotes />;
      case 'ledger':
        return <PatientLedger />;
      default:
        // Default to appointments if no specific path
        return <PatientAppointments />;
    }
  };

  return getCurrentComponent();
};

export default PatientDetailOutlet;
